import { DIRECTIONS } from "@/views/academy/constants/directions";
import AcademyDirectionCard from "@/views/academy/components/list/academy-direction-card";
import { Container } from "@/components/ui/container";
import S from "./index.module.scss";

const ListAcademy = () => {
  return (
    <Container className={S.wrapper}>
      {DIRECTIONS.map((dir, idx) => (
        <AcademyDirectionCard card={dir} key={idx} />
      ))}
    </Container>
  );
};

export default ListAcademy;
